export default __webpack_public_path__ + "static/media/construction_iso.22746130.png";